import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../data";
import { Reveal, Eyebrow } from "./Reveal";

export const Services = ({ onQuote }) => (
  <section id="services" data-testid="services-grid" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>What we do</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight">
          Heating, plumbing <span className="flame-text">& bathrooms</span>
        </h2>
        <p className="mt-4 text-lg text-zinc-400">
          Five core services, one trusted local team. Quality work, every time.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const wide = i === 0 || i === 3;
          return (
            <Reveal
              key={s.id}
              delay={(i % 3) * 0.08}
              className={wide ? "lg:col-span-2" : ""}
            >
              <motion.article
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                data-testid={`service-card-${s.id}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[#121217]"
              >
                <div className={`grid ${wide ? "sm:grid-cols-2" : ""} h-full`}>
                  <div className="relative overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${wide ? "h-56 sm:h-full" : "h-48"}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#121217] via-[#121217]/20 to-transparent" />
                    <div className="absolute top-4 left-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#f5641e]">
                      <Icon className="h-5 w-5 text-[#0a0a0c]" />
                    </div>
                  </div>
                  <div className="p-6 flex flex-col">
                    <div className="flex items-start justify-between gap-3">
                      <h3 className="font-display text-xl sm:text-2xl font-bold">{s.title}</h3>
                      <ArrowUpRight className="h-5 w-5 shrink-0 text-zinc-600 transition-colors group-hover:text-[#f5641e]" />
                    </div>
                    <p className="mt-2 text-zinc-400">{s.blurb}</p>
                    <ul className="mt-4 space-y-2">
                      {s.points.map((p) => (
                        <li key={p} className="flex items-center gap-2 text-sm text-zinc-300">
                          <Check className="h-4 w-4 text-[#f5641e]" /> {p}
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={onQuote}
                      data-testid={`service-quote-${s.id}`}
                      className="mt-auto pt-5 text-left font-mono-sx text-xs uppercase tracking-widest text-[#f5641e] hover:text-[#ff7a38]"
                    >
                      Enquire about {s.title} →
                    </button>
                  </div>
                </div>
              </motion.article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
